import styled from "styled-components";

export const ErrorCrossIconWrapper = styled.div`
  width: 14px;
  height: 14px;
  margin-right: 8px;
`;
